module.exports = __webpack_public_path__ + "static/media/kokolingo.80a8cf45.svg";